import { render, staticRenderFns } from "./lihuiweihu.vue?vue&type=template&id=0fe4a60f"
import script from "./lihuiweihu.vue?vue&type=script&lang=js"
export * from "./lihuiweihu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports